import { createAction, props } from '@ngrx/store';
import { USER_ROLES } from '../../services/api.service';

const USER_KEY = '[User]';

export const GetUser = createAction(
  `${USER_KEY} get user`
);

export const GetUserSuccess = createAction(
  `${USER_KEY} get user success`,
  props<{ payload: any }>()
);

export const GetUserFailure = createAction(
  `${USER_KEY} get user failure`,
  props<any>()
);

export const SetUserRole = createAction(
  `${USER_KEY} set user role`,
  props<{ role: USER_ROLES }>()
);

export const SetUserRoleSuccess = createAction(
  `${USER_KEY} set user role success`,
  props<{ role: USER_ROLES }>()
);

export const SetUserAvatar = createAction(
  `${USER_KEY} set user avatar`,
  props<{ payload: any }>()
);

export const SetUserAvatarSuccess = createAction(
  `${USER_KEY} set user avatar success`,
  props<{ avatar: string }>()
);

export const SetUserScore = createAction(
  `${USER_KEY} set user score`,
  props<{ score: number }>()
);

export const SetUserPreData = createAction(
  `${USER_KEY} set user pre data`,
  props<{ id: string, email: string, name: string, onBoardingRole: string, files: any }>()
);

export const SaveUserProfileSuccess = createAction(
  `${USER_KEY} save user profile success`
);

export const SetUserEmail = createAction(
  `${USER_KEY} set user email`,
  props<{ email: string }>()
);

export const SetUserName = createAction(
  `${USER_KEY} set user name`,
  props<{ name: string }>()
);

export const SetUserIncognito = createAction(
  `${USER_KEY} set user incognito`,
  props<{ incognito: boolean }>()
);

export const SetUserPublic = createAction(
  `${USER_KEY} set user public`,
  props<{ public: boolean }>()
);

export const SetHardSkills = createAction(
  `${USER_KEY} set hard skills`,
  props<{ skillsList: any[], noDebounce?: boolean }>()
);

export const SetHardSkillsSuccess = createAction(
  `${USER_KEY} set hard skills success`,
);

export const SetSoftSkills = createAction(
  `${USER_KEY} set soft skills`,
  props<{ skillsList: any[] }>()
);

export const SetTalentDetails = createAction(
  `${USER_KEY} set user details`,
  props<{ details: any }>()
);

export const SetTalentExpectations = createAction(
  `${USER_KEY} set user expectations`,
  props<{ expectations: any }>()
);

export const SetTalentContacts = createAction(
  `${USER_KEY} set user contacts`,
  props<{ contacts: any }>()
);

export const SetTalentTelegram = createAction(
  `${USER_KEY} set talent telegram`,
  props<{ telegram: any }>()
);

export const GetTalentSkills = createAction(
  `${USER_KEY} get talent skills`
);

export const GetTalentSkillsSuccess = createAction(
  `${USER_KEY} get talent skills success`,
  props<{ hardSkills: any, softSkills: any }>()
);

export const GetSkillsList = createAction(
  `${USER_KEY} get skills list`
);

export const GetSkillsListSuccess = createAction(
  `${USER_KEY} get skills list success`,
  props<{ skillsList: any[] }>()
);

export const GetSkillsListFailure = createAction(
  `${USER_KEY} get skills list failure`,
  props<{ err: any }>()
);

export const GetJobTitles = createAction(
  `${USER_KEY} get job titles`
);

export const GetJobTitlesSuccess = createAction(
  `${USER_KEY} get job titles success`,
  props<{ jobTitles: any[] }>()
);

export const GetJobTitlesFailure = createAction(
  `${USER_KEY} get job titles failure`,
  props<{ err: any }>()
);

export const SetHmAboutYou = createAction(
  `${USER_KEY} set user about you`,
  props<{ aboutYou: any }>()
);

export const SetHmTelegram = createAction(
  `${USER_KEY} set hm telegram`,
  props<{ telegram: any }>()
);

export const SetHmCompany = createAction(
  `${USER_KEY} set user company`,
  props<{ company: any }>()
);

export const SetHmFinance = createAction(
  `${USER_KEY} set user finance`,
  props<{ finance: any }>()
);

export const SetMessageCount = createAction(
  `${USER_KEY} set message count`,
  props<{ count: number }>()
);

export const SetAppliesCount = createAction(
  `${USER_KEY} set applies count`,
  props<{ count: number }>()
);

export const SetNotifyCount = createAction(
  `${USER_KEY} set notify count`,
  props<{ count: number }>()
);

export const SetLastTreadUpdated = createAction(
  `${USER_KEY} set last thread updated`,
  props<{ threadId: string }>()
);

export const SetCompanyLogo = createAction(
  `${USER_KEY} set company logo`,
  props<{ payload: any }>()
);

export const SetCompanyLogoSuccess = createAction(
  `${USER_KEY} set company logo success`,
  props<{ logo: string }>()
);

export const UploadUserFile = createAction(
  `${USER_KEY} upload user file`,
  props<{ payload: any }>()
);

export const UploadUserFileSuccess = createAction(
  `${USER_KEY} upload user file success`,
  props<{ payload: any }>()
);

export const DeleteUserFile = createAction(
  `${USER_KEY} delete user file`,
  props<{ payload: any }>()
);

export const DeleteUserFileSuccess = createAction(
  `${USER_KEY} delete user file success`,
  props<{ fileUrl: any }>()
);

export const TalentDefaultCv = createAction(
  `${USER_KEY} set talent default cv`,
  props<{ payload: any }>()
);

export const SetTalentSeniority = createAction(
  `${USER_KEY} set talent seniority`,
  props<{ level: string }>()
);

export const SetTalentSenioritySuccess = createAction(
  `${USER_KEY} set talent seniority success`,
  props<{ level: string }>()
);

export const SetTalentSeniorityFailure = createAction(
  `${USER_KEY} set talent seniority failure`
);

export const GetTalentSkillsTree = createAction(
  `${USER_KEY} get talent skills tree`
);

export const GetSkillsValidation = createAction(
  `${USER_KEY} get talent skills validation`
);

export const GetSkillsValidationSuccess = createAction(
  `${USER_KEY} get talent skills validation success`,
  props<{ payload: any }>()
);